module.exports = __webpack_public_path__ + "img/answer-ceramic.7488fca9.webp";